export default __webpack_public_path__ + "static/media/Snd2.89cec752.mp3";